<template>
  <div>
    <div class="border p-2 mb-3">
      <p class="pt-2" v-b-toggle.search-filter>
        جستجوی محصول
        <b-icon icon="arrow-down-circle"></b-icon>
      </p>
      <b-collapse visible id="search-filter">
        <hr />
        <b-form-input
            @keypress.enter.prevent="searchProduct"
            v-model="searchState"
            placeholder="نام محصول را بنویسید"
        ></b-form-input>
      </b-collapse>
    </div>
    <div class="border pr-2 mb-3">
      <p class="pt-2" v-b-toggle.categories-filter>
        دسته بندی ها
        <b-icon icon="arrow-down-circle"></b-icon>
      </p>
      <b-collapse id="categories-filter">
        <hr />
        <Category
            :filterAction="filterAction"
            :selected-category="selectedCategory"
            :margin="0"
            v-for="category in categories"
            :key="category.id"
            :category="category"
            class="pr-2 drug-font"
            :categoryId="isSidebar"
        />
      </b-collapse>
    </div>
    <div class="border pr-2 mb-3">
      <p class="pt-2" v-b-toggle.brands-filter>
        برندها
        <b-icon icon="arrow-down-circle"></b-icon>
      </p>

      <b-collapse id="brands-filter">
        <hr />
        <div v-for="brand in brands" :key="brand.id">
          <input
              type="checkbox"
              :value="brand.id"
              :id="`${isSidebar}_brand_${brand.id}`"
              :checked="selectedBrands.indexOf(brand.id.toString()) > -1"
              @change="filterByBrand"
          />
          <label
              class="mr-1 pr-2 drug-font"
              :for="`${isSidebar}_brand_${brand.id}`"
          >{{ brand.name }}</label
          >
        </div>
      </b-collapse>
    </div>
    <div class="border pt-2">
      <p class="pr-2" v-b-toggle.price-filter>
        محدوده قیمت مورد نظر
        <b-icon icon="arrow-down-circle"></b-icon>
      </p>

      <b-collapse id="price-filter">
        <hr />
        <div class="range-slider w-75">
          <div class="row TOP">
            <div class="col-6 border">
              <div class="col-4">از</div>
              <div class="col-4">{{ format(price.minValue) }}</div>
              <div class="col-4">تومان</div>
            </div>
            <hr />
            <div class="col-6 border">
              <div class="col-6">تا</div>
              <div class="col-6">{{ format(price.maxValue) }}</div>
              <div class="col-6">تومان</div>
            </div>
          </div>
          <input
              value="25000"
              min="0"
              max="120000"
              step="500"
              type="range"
              v-model="price.minValue"
              @change.prevent="format(price.minValue)"
          />
          <input
              value="50000"
              min="0"
              max="120000"
              step="500"
              type="range"
              v-model="price.maxValue"
              @change.prevent="format(price.maxValue)"
          />
        </div>
        <hr />
        <div class="pr-5 mb-4">
          <button class="py-2 Color w-75" @click="filterByPrice">
            اعمال محدوده قیمت
          </button>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { formatNumber } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import { mapGetters } from "vuex";

import Category from "./category";
import router from "@/router";

export default {
  name: "filters",
  props: ["isSidebar"],
  components: { Category },
  data() {
    return {
      price: {
        minValue: 0,
        maxValue: 1000000000,
      },
    };
  },
  methods: {
    formatNumber,
    format(e) {
      e = parseInt(e);
      return formatNumber(e);
    },
    filterByPrice() {
      router.push({
        name: "Products",
        query: {
          ...router.currentRoute.query,
          price: `${this.getPrice.minValue}-${this.getPrice.maxValue}`,
        },
      });

      this.filterAction();
    },

    filterByBrand(e) {
      // change url query base on selectedBrand if selectedBrand is not empty other wise remove brand query
      const selectedBrand = this.selectedBrands;
      const value = e.target.value;
      const query = Object.assign({}, router.currentRoute.query);
      if (e.target.checked) {
        selectedBrand.push(value);
        this.$store.commit("Product/setFilters", {
          key: "brand",
          value: selectedBrand,
        });
      } else {
        selectedBrand.splice(selectedBrand.indexOf(value), 1);
        this.$store.commit("Product/setFilters", {
          key: "brand",
          value: selectedBrand,
        });
      }
      if (this.selectedBrands.length > 0) {
        query.brand = this.selectedBrands.join(",");
        router.push({
          name: "Products",
          query: { ...router.currentRoute.query, brand: query.brand },
        });
      } else {
        delete query.brand;
        router.push({
          name: "Products",
          query: query,
        });
      }

      this.filterAction();
    },
    searchProduct() {
      const query = Object.assign({}, router.currentRoute.query);
      if (
          this.$store.getters["Product/getFilter"]("search").trim().length > 0
      ) {
        query.search = this.$store.getters["Product/getFilter"]("search");
        router.push({
          name: "Products",
          query: { ...router.currentRoute.query, search: query.search },
        });
      } else {
        delete query.search;
        router.push({
          name: "Products",
          query: query,
        });
      }
      this.filterAction();
    },
    filterAction() {
      if (this.$store.getters["Product/getFilter"]("search").trim().length !== 0) {
        this.$store.dispatch("Product/filteredProducts");
      }
    },
    async setFilterOptions() {
      let brand = router.currentRoute.query.brand;
      if (brand !== undefined) {
        const brands = [];

        if (brand.length > 1) {
          brand.split(",").forEach((b) => {
            brands.push(b);
          });
        } else {
          brands.push(brand);
        }
        this.$store.commit("Product/setFilters", {
          key: "brand",
          value: brands,
        });
      } else {
        this.$store.commit("Product/setFilters", { key: "brand", value: [] });
      }
      let category = await router.currentRoute.query.category;
      if (category !== undefined) {
        const categories = [];

        if (category.length > 1) {
          await category.split(",").forEach((c) => {
            categories.push(c.toString());
          });
        } else {
          categories.push(category.toString());
        }
        this.$store.commit("Product/setFilters", {
          key: "category",
          value: categories,
        });
      } else {
        this.$store.commit("Product/setFilters", {
          key: "category",
          value: [],
        });
      }
      let search = await router.currentRoute.query.search;
      search == null ? "null" : "not null";
      if (search != undefined) {
        this.$store.commit("Product/setFilters", {
          key: "search",
          value: search,
        });
      } else {
        this.$store.commit("Product/setFilters", { key: "search", value: "" });
      }
      let status = await router.currentRoute.query.status;
      if (status != undefined) {
        this.$store.commit("Product/setFilters", {
          key: "status",
          value: status,
        });
      }
      let price = await router.currentRoute.query.price;
      if (price != undefined) {
        price = price.split('-');
        price ={minValue:price[0],maxValue:price[1]}
        this.$store.commit("Product/setFilters", {
          key: "price",
          value: price,
        });
        this.price = price;
        console.log(this.$store.getters['Product/getFilter']('price'))
      }
      this.filterAction();
    },
  },
  async mounted() {
    await this.$store.dispatch("Brand/getBrands");
    await this.$store.dispatch("Category/getCategories");

    await this.setFilterOptions();
  },
  watch: {
    $route: {
      async handler(newVal, oldVal) {
        if (oldVal != newVal) {
          await this.setFilterOptions();
        }
      },
    },
    price: {
      handler(val, oldVal) {
        this.$store.commit("Product/setFilters", { key: "price", value: val });
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      brands: "Brand/getBrands",
      categories: "Category/getCategories",
    }),
    selectedCategory() {
      return this.$store.getters["Product/getFilter"]("category");
    },
    selectedBrands() {
      return this.$store.getters["Product/getFilter"]("brand");
    },
    getPrice() {
      return this.$store.getters["Product/getFilter"]("price");
    },
    changeMinPrice: {
      get() {
        this.$store.getters["Product/getFilter"]("minValue");
      },
      set(value) {
        this.$store.commit("Product/setFilters", {
          key: "minValue",
          value: value,
        });
      },
    },
    changeMaxPrice: {
      get() {
        this.$store.getters["Product/getFilter"]("maxValue");
      },
      set(value) {
        this.$store.commit("Product/setFilters", {
          key: "maxValue",
          value: value,
        });
      },
    },
    searchState: {
      get() {
        this.$store.getters["Product/getFilter"]("search");
      },
      set(value) {
        this.$store.commit("Product/setFilters", {
          key: "search",
          value: value,
        });
      },
    },
  },
};
</script>

<style scoped>
.drug-font {
  font-size: 0.9rem;
  color: #878885;
}

.Color {
  background-color: #7cc7ff;
  border-radius: 5px;
  color: white;
  font-size: 0.8rem;
  border: 0.5px solid darkgrey;
}

.range-slider {
  width: 300px;
  margin: auto;
  text-align: center;
  position: relative;
  height: 6em;
}

.range-slider svg,
.range-slider input[type="range"] {
  position: absolute;
  left: 0;
  bottom: 0;
}

input[type="number"] {
  border: 1px solid #ddd;
  text-align: center;
  font-size: 1.6em;
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"]:invalid,
input[type="number"]:out-of-range {
  border: 2px solid #ff6347;
}

input[type="range"] {
  -webkit-appearance: none;
  width: 100%;
}

input[type="range"]:focus {
  outline: none;
}

input[type="range"]:focus::-webkit-slider-runnable-track {
  height: 1px;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 1px;
  cursor: pointer;
  animation-duration: 0.2s;
  background: #a9b1a5;
  border-radius: 1px;
  box-shadow: none;
  border: 0;
}

input[type="range"]::-webkit-slider-thumb {
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #a9b1a5;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: white;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;
}
</style>